module.exports = __webpack_public_path__ + "img/listria_b2.587df5c8.jpg";